// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Ryiy","label":"Radio_label__2VtbM","checkMark":"Radio_checkMark__2ef_N","disabled":"Radio_disabled__DkPl9"};